import api from 'services/api';

/**
 * PUT `/python_libraries/:id/node_definitions`. REPLACES the whole set of links: the backend
 * deletes every row for this library and re-inserts the ids given, in one transaction. So the
 * caller must send the complete desired set — an empty array unlinks everything, and there is no
 * add-one / remove-one form of this call.
 *
 * Resolves on success; throws on HTTP error so the caller can surface the message. The 200 body
 * echoes `{ python_library_id, node_definition_ids }` — the request, not server-derived state, so
 * there is nothing to validate or return.
 */
export const putPythonLibraryNodeDefinitions = async (id: number, nodeDefinitionIds: readonly number[]): Promise<void> => {
  await api.put(`/python_libraries/${id}/node_definitions`, { node_definition_ids: nodeDefinitionIds });
};
